import React from 'react';

import { capitalize } from 'lodash';

/**
 * Type of the lead, free, premium or with rendez-vous
 * @param {Object} props {type, fullText, partner}
 * @returns {JSX.Element} TypeOfLead
 * @constructor
 */
const TypeOfLead = props => {
  const quinze_points = {
    type: '',
    message: '',
  };

  const isLeadPrestige = props.opportunity.isPrestigeEstimate ? ' Luxe & Prestige' : '';

  if (props.partner === 'CHERCHEMONNID') {
    quinze_points.type = 'LEAD CHERCHE MON NID';
    quinze_points.message = '(Tarif: 15 points de commission en cas de transaction)';
  }

  let types = {
    free: {
      type: `Lead gratuit${isLeadPrestige}`,
      message: props.partner === 'CAPIFRANCE_JEUCONCOURS2022' ? '(Souhait mise en relation)' : '',
    },
    cinq_points: {
      type: `Lead premium${isLeadPrestige}`,
      message: '(Tarif : 5pts de commission en cas de transaction)',
    },
    dix_points: {
      type: `Lead${isLeadPrestige}`,
      message: '(Tarif: 10 points de commission en cas de transaction)',
    },
    dix_points_rdv: {
      type: 'Avec rendez-vous',
      message: '',
    },
    quatorze_points: {
      type: 'Lead Drimki',
      message: ' - 14 pts de commission en cas de transaction.',
    },
    ...{ quinze_points },
  };

  const billingType = (billingType, fullText = false) => {
    const type = billingType.toString().toLowerCase();
    if (types[type]) {
      return fullText ? types[type].type + ' ' + types[type].message : types[type].type;
    }

    return capitalize(type);
  };

  return <span>{billingType(props.type, props.fullText)}</span>;
};

export default TypeOfLead;
